import styles from './FJMenuTab.module.less';
import { useMemo, memo } from 'react';
import classNames from 'classnames';
import FJLocalStore from '../../../store/FJLocalStore';
import useLocalStore from '../../../hooks/useLocalStore.js';

function FJMenuTab(props) {
    useLocalStore();
    const { list = [], curIndex = 0, onChange, className, style } = props;

    const left = useMemo(() => {
        return curIndex * (100 / list.length) + '%';
    }, [curIndex, list.length]);

    return (
        <div className={classNames(styles.box, className)} style={style}>
            <div className={styles.bk} style={{ left: left, width: 100 / (list.length || 2) + '%' }}>
                <div className={styles.inner} />
            </div>
            <ul className={styles.tab}>
                {list.map((item, index) => {
                    return (
                        <li
                            key={index}
                            onClick={() => {
                                onChange(index);
                            }}
                            className={index === curIndex ? styles.active : ''}
                        >
                            {FJLocalStore._(item.text)}
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

export default memo(FJMenuTab);
